import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'app/core/services/auth/auth.service';
import { VerificationsService } from 'app/core/services/factoring/verifications.service';

@Component({
  selector: 'app-devolver-operacion-modal',
  templateUrl: './devolver-operacion-modal.component.html',
  styleUrls: ['./devolver-operacion-modal.component.css']
})
export class DevolverOperacionModalComponent implements OnInit {
  myForm                  : FormGroup;
  @Output() successEmit   : EventEmitter<any> = new EventEmitter<any>();
  motivos                 : any[] = [];
  idOperacion: any;
  faTimes = faTimes;
  constructor(
    public activeModal : NgbActiveModal,
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private verificacionService: VerificationsService,
  ) { 
    this.initForm();
  }

  ngOnInit(): void {
  }

  initForm() {

    this.verificacionService.obtenerMotivosDevolucion().then((res:any)=>{
      this.motivos = res.results
    })


    this.myForm = this.formBuilder.group({
      motivo      : [null, [Validators.required]],
      comentario  : [null, [Validators.required]]
    });
  }
  onSubmit() {
    this.successEmit.emit(this.myForm.value)
  }
}
